<template>
  <div v-if="$page">
    <header ref="header" class="header">
      <figure v-scroll:parallax="{ refNode: $refs.header, ratio: 0.15 }" class="header__background">
        <Image v-if="$page.headerImg" :source="$page.headerImg" />
      </figure>

      <div class="header__content">
        <h1 v-scroll:reveal="{ delay: 550 }" class="header__legend">{{ $page.title }}</h1>
        <h2 v-scroll:reveal="{ delay: 600 }" class="header__title">{{ $page.headerTitleTop }}</h2>
        <h3 v-scroll:reveal="{ delay: 650 }" class="header__title">
          {{ $page.headerTitleBottom }}
        </h3>
      </div>
    </header>

    <section class="section -article-index" :id="$t('post.anchor')">
      <div v-if="$store.getters.post_categories.length" class="row -column">
        <div class="form-filter-article">
          <p class="form-filter-article__label">{{ $page.filterTitle }}</p>
          <select id="select" v-model="selectedCategory" name="type">
            <option value="">{{ $t('all_categories') }}</option>
            <option
              v-for="category in $store.getters.post_categories"
              :key="`category-${category.id}`"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </select>
        </div>
      </div>
      <div>
        <div class="list-article">
          <div
            v-for="post in displayed_posts"
            :key="`post-${post.id}-card`"
            class="list-article__single"
          >
            <PostCard :post="post" />
          </div>
        </div>
        <button
          v-if="filtered_posts.length > displayed_posts.length"
          class="list-article__button button -border"
          @click="count += 6"
        >
          {{ $page.blogBtnLabel }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import PostCard from '@/components/cards/PostCard.vue'
import Image from '@/components/global/Image.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'ArticlesIndex',
  beetPage: 'post_index',
  mixins: [PageMetaMixin],
  components: { Image, LangRouterLink, PostCard },
  data() {
    return {
      count: 6,
    }
  },
  computed: {
    filtered_posts() {
      return this.$route.query.type
        ? this.$store.getters.posts_by_category(this.$route.query.type)
        : this.$store.getters.posts
    },
    displayed_posts() {
      return this.filtered_posts.slice(0, this.count)
    },
    selectedCategory: {
      get() {
        return this.$route.query.type || ''
      },
      set(value) {
        this.$router.push({
          hash: `#${this.$t('post.anchor')}`,
          query: value !== '' ? { ...this.$route.query, type: value } : {},
        })
      },
    },
  },
  mounted() {
    this.$store.dispatch('loadPosts')
    this.$store.dispatch('loadPostCategories')
  },
}
</script>
